import html2canvas from "html2canvas";
import jsPDF from "jspdf";
const exportAsImage = async (el, imageFileName) => {
  const canvas = await html2canvas(el, {
    width: el.offsetWidth,
    height: el.offsetHeight,

    onclone: function (document) {
      document.querySelector(".navbar").style.display = "none";
      document.querySelector(
        ".gaugeComponent"
      ).style.background = `radial-gradient(
        circle at bottom,
        rgba(255, 255, 255, 1) 65%,
        rgb(0 0 0 / 0%) 65%
      )`;
    },
  });
  const image = canvas.toDataURL("image/png");

  const pdf = new jsPDF({
    orientation: "p",
    unit: "px",
    format: [canvas.width, canvas.height],
    hotfixes: ["px_scaling"],
  });
  pdf.addImage(image, "png", 0, 0);
  pdf.save("result.pdf");
};

// const downloadImage = (blob, fileName) => {
//   const fakeLink = window.document.createElement("a");
//   fakeLink.style = "display:none;";
//   fakeLink.download = fileName;
//   fakeLink.href = blob;
//   document.body.appendChild(fakeLink);
//   fakeLink.click();
//   document.body.removeChild(fakeLink);
//   fakeLink.remove();
// };
const dataURLtoFile = (dataurl, filename) => {
  var arr = dataurl.split(","),
    mimeType = arr[0].match(/:(.*?);/)[1],
    decodedData = atob(arr[1]),
    lengthOfDecodedData = decodedData.length,
    u8array = new Uint8Array(lengthOfDecodedData);
  while (lengthOfDecodedData--) {
    u8array[lengthOfDecodedData] = decodedData.charCodeAt(lengthOfDecodedData);
  }
  return new File([u8array], filename, { type: mimeType });
};
const shareImage = async (el, imageFileName, text = "", title = "") => {
  const canvas = await html2canvas(el);
  const image = canvas.toDataURL("image/png", 1.0);
  const file = dataURLtoFile(image, imageFileName);
  shareFile(file, text, title);
};

const shareFile = (file, title, text) => {
  // if(navigator.canShare)console.log('you can share')
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    navigator
      .share({
        files: [file],
        title,
        text,
      })
      .then(() => console.log("Share was successful."))
      .catch((error) => console.log("Sharing failed", error));
  } else {
    console.log(`Your system doesn't support sharing files.`);
  }
};

const shareText = (url, title, text) => {
  // if(navigator.canShare)console.log('you can share')
  if (navigator.canShare) {
    navigator
      .share({
        url,
        title,
        text,
      })
      .then(() => console.log("Share was successful."))
      .catch((error) => console.log("Sharing failed", error));
  } else {
    console.log(`Your system doesn't support sharing files.`);
  }
};

export { exportAsImage, shareImage, shareText };
